module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('ul', {
    staticClass: "detail list"
  }, [_c('li', [_vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.emailadres) + " "), _c('a', {
    staticClass: "edit",
    attrs: {
      "href": _vm.ctx + '/login-ingelogd/emailadres-wijzigen.html'
    }
  }, [_vm._v("wijzig "), _c('span', {
    staticClass: "icon clean"
  }, [_vm._v(">")])])])]), _vm._v(" "), (_vm.mobiel) ? _c('li', [_c('p', [_vm._v("Telefoonnummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.mobiel))])]) : _vm._e(), _vm._v(" "), (_vm.vast) ? _c('li', [_c('p', [_vm._v("Telefoonnummer")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.vast))])]) : _vm._e()])])]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h3', [_c('span', [_vm._v("Contactgegevens")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("E-mailadres \n\t\t\t\t\t\t"), _c('a', {
    staticClass: "modal-button",
    attrs: {
      "role": "button",
      "data-toggle": "modal",
      "data-target": "#email-modal"
    }
  }, [_vm._v("j")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "email-modal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("E-mailadres")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n\t\t        Let op! Uw e-mailadres is ook uw gebruikersnaam. Past u uw e-mailadres aan, dan is dit ook uw nieuwe gebruikersnaam wanneer u inlogt.\n\t\t      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Ok")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7551efd1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/mijngegevens/contactgegevens.vue
// module id = 38
// module chunks = 0